// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    name: 'g-login-login',
    data: () => ({
        userName: "",
        password: "",
        errorMessage: "",
        isLoading: false
    }),
    created() {
        this.userName = host.login.getUsername() ?? '';
    },
    watch: {
        userName: function (val) {
            this.errorMessage = '';
        },
        password: function (val) {
            this.errorMessage = '';
        }
    },
    computed: {
        hasError() {
            return !utils.isEmpty(this.errorMessage);
        },
        disableLogin() {
            return utils.isEmpty(this.userName) || utils.isEmpty(this.password);
        }
    },
    methods: {
        runLogin() {
            // #region Check
            //Reset
            this.errorMessage = "";
            //Check
            if (this.isLoading) {
                return;
            }
            if (utils.isEmpty(this.userName)) {
                return;
            }
            if (utils.isEmpty(this.password)) {
                return;
            }
            // #endregion
            // #region Run
            //Loading
            this.isLoading = true;
            host.login.loginByUsername(this.userName, this.password).then((e) => {
                //Reset
                this.isLoading = false;
                if (!e.isSucceded && e.errorCode === "account_activate") {
                    let tRequest = {
                        name: "login-activate",
                        params: {
                            userId: e.customData.userId
                        },
                        query: {
                            returnUrl: this.$route.query?.returnUrl
                        }
                    };
                    this.$router.push(tRequest);
                }
                else if (!e.isSucceded) {
                    this.errorMessage = e.errorMessage;
                }
                else if (this.$route.query?.returnUrl || this.$route.query?.ReturnUrl) {
                    //Parse
                    let tUrl = decodeURIComponent((this.$route.query?.returnUrl ?? this.$route.query?.ReturnUrl));
                    //Special
                    window.location.href = tUrl;
                }
                else {
                    this.$router.push("/");
                }
            })
                .catch((e) => {
                // #region Meter
                this.isLoading = false;
                // #endregion
                // #region Set
                this.errorMessage = utils.getAxiosErrorMessage(e);
                // #endregion
            });
            // #endregion
        },
        runOIDC() {
            window.location.href = '/oidc/challenge';
        },
    }
});
// #endregion
